import { cn } from '@/lib/utils'

/** Key hint shown beside actions so cashiers learn shortcuts by sight. Hidden on touch-only widths. */
export const Kbd = ({ children, className, dark }: { children: string; className?: string; dark?: boolean }) => (
  <kbd
    className={cn(
      'hidden h-5 min-w-5 items-center justify-center rounded-xs border px-1 font-sans text-micro md:inline-flex',
      dark ? 'border-sidebar-border bg-sidebar-hover text-sidebar-foreground' : 'border-border bg-subdued text-muted-foreground',
      className
    )}
  >
    {children}
  </kbd>
)
